import * as React from 'react';

import { WebviewHandlersWrapper } from '../WebviewHandlersWrapper';
import { SummaryContainer } from '../Summary';
import { PublicationContainer } from '../Publication';
import { LogError } from '../common/ReactErrorLog';
import { PromotionContainer } from '../Promotion';
import { MessageWrapper } from '../Messages';
import { useAdaptiveSettings } from '../../../common/hooks';
import { usePublishTermsLoadingTelemetry } from '../PublishTerms/hooks';
import { DemandBannerContainer } from '../DemandBanner';

export const ServicePickerWidget = () => {
  useAdaptiveSettings();
  usePublishTermsLoadingTelemetry();

  return (
    <div data-testid="service-picker-widget">
      <WebviewHandlersWrapper>
        <LogError>
          <DemandBannerContainer />

          <PublicationContainer />

          <PromotionContainer />

          <MessageWrapper />

          <SummaryContainer />
        </LogError>
      </WebviewHandlersWrapper>
    </div>
  );
};
